import {Line, mixins} from 'vue-chartjs';

const {reactiveProp} = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    options(newOption, oldOption) {
      this.renderChart(this.chartData, newOption);
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    const {options} = this;
    this.chartData.datasets.sort((a, b) => ((a.label.localeCompare(b.label))));
    this.renderChart(this.chartData, options);
  },
};
